import { Component, OnInit } from '@angular/core';
import { BoxService } from '../../services/box.service';
import { BoxMessage } from '../../models/boxmessage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-obstructed',
  templateUrl: './obstructed.component.html',
  styleUrls: ['./obstructed.component.scss']
})
export class ObstructedComponent implements OnInit {

  constructor(private boxService: BoxService) { }

  ngOnInit(): void {
  }

}
